import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modal", "nameInput"];

  open(event) {
    event.preventDefault();
    this.modalTarget.classList.remove("hidden");
    document.body.style.overflow = "hidden";
    // Focus the first input after the transition
    requestAnimationFrame(() => {
      this.nameInputTarget.focus();
    });
  }

  close(event) {
    if (event) event.preventDefault();
    this.modalTarget.classList.add("hidden");
    document.body.style.overflow = "";
  }

  closeOnBackdrop(event) {
    if (event.target === this.modalTarget) {
      this.close(event);
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape" && !this.modalTarget.classList.contains("hidden")) {
      this.close(event);
    }
  }
}
